import { get } from 'lodash';
import axiosClient from './axios';

const getListTasks = async (jobId: string, joinData: any) => {
  return axiosClient.post(`/v1/match/get`, {
    jobCode: jobId,
    joinData: ['freelancer', 'job'],
  });
};

const getTaskPayment = async (param: any) => {
  return axiosClient.get(`/v1/get/payments?matchCode=${param}`);
};

const getDetailPayment = async (paymentId: any) => {
  return axiosClient.get(`/v1/payment/getOne?paymentCode=${paymentId}`);
};

const updatePayment = async (paymentCode: any, matchCode: any, refType: any, log: any, subject: any, status: any) => {

  return axiosClient.put(`/v1/payment/update`, {
    paymentCode: paymentCode,
    matchCode: matchCode,
    refType: refType,
    log: log,
    subject: subject,
    object: null,
    status: status,
  });
};

const updateEndTask = async (maskId: any, endPeriod: string, endTaskMessage: string) => {
  return axiosClient.put(`/v1/match/update`, {
    matchCode: maskId,
    status: 'hired',
    taskStatus: 'completed',
    endPeriod,
    endTaskMessage,
  });
};

const updatePaymentStatus = async (maskId: string) => {
  return axiosClient.put(`/v1/match/update`, {
    matchCode: maskId,
    status: 'hired',
    paymentStatus: 'paid'
  });
};

const financeUpdateToPaid = async (matchCode: string) => {
  const payload = {
    matchCode: matchCode
  };

  const response = await axiosClient.put('/v1/offer/updateToPaid', payload);

  return response.data?.result;
};

const getPaymentSalaryApi = async (matchId: string) => {
  return axiosClient.get(`/v1/offer/getOne?matchCode=${matchId}`);
};

const getTaskCount = async () => {
  try {
    const response = await axiosClient.get(`/v1/match/countByTaskStatus`);
    return get(response, 'result', null);
  } catch (error) { }
};

const getTasksApi = async (params: {
  page: number;
  recordPerPage: number;
  taskStatus: 'inProgress' | 'completed' | null;
  status?: string;
  sort: 'arc' | 'des';
  search?: string;
}) => {
  try {
    const response = await axiosClient.post(`v1/admin/task/get`, params);
    return get(response, 'result', null);
  } catch (error) { }
};

const updateLinkTask = async (type: 'timeSheet' | 'taskManagement', value: string, matchCode: string) => {
  try {
    return await axiosClient.put(`/v1/match/update`, {
      matchCode,
      [type]: value,
    });
  } catch (error) { }
};

export {
  getListTasks,
  getTaskPayment,
  getDetailPayment,
  updatePayment,
  updateEndTask,
  updatePaymentStatus,
  getPaymentSalaryApi,
  getTaskCount,
  getTasksApi,
  updateLinkTask,
  financeUpdateToPaid,
};
